<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.ServerInstallationDownload"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="false"
  badgeTranslationKey="site_setup_contract_ffd_install"
></lib-site-setup-navbar>
<div class="mt-2 font-poppins text-[30px] font-medium leading-[45px] tracking-[-0.7px] text-[#595959]">
  <span>{{ 'site_setup_checklist_download_part1' | translate }}</span
  ><br /><span class="text-background border-0 border-r-2 border-solid border-primary-blue">{{
    'site_setup_checklist_download_part2' | translate
  }}</span>
</div>

<a
  href="https://secure.ffd.ai/ffd_install.exe"
  class="btn-primary mt-5 flex h-10 w-full items-center justify-center"
  [ffdPushTagOnClick]="{
    event: TagEvent.ServerInstallationDownloaded,
    contract_id: vm().contract?.data?.id
  }"
>
  {{ 'site_install_server_installation_download_button' | translate }}
</a>

<p class="typo-h4-light my-5 font-poppins font-light leading-[24px] text-text-light">
  {{ 'site_install_server_installation_finished_downloading_label' | translate }}
</p>

<div class="flex flex-col gap-3">
  <div class="typo-h4-light flex gap-2 font-poppins font-light leading-[24px] text-text-light">
    <span>1.</span>
    <span [innerHtml]="'site_install_server_installation_step1_description' | translate | markdown | async"></span>
  </div>
  <img src="/assets/images/download-mockup.png" />
  <div class="typo-h4-light flex gap-2 font-poppins font-light leading-[24px] text-text-light">
    <span>2.</span>
    <span [innerHtml]="'site_install_server_installation_step2_description_v2' | translate | markdown | async"></span>
  </div>
  <div class="typo-h4-light flex gap-2 font-poppins font-light leading-[24px] text-text-light">
    <span>3.</span>
    <span [innerHtml]="'site_install_server_installation_step3_description_v2' | translate | markdown | async"></span>
  </div>
</div>
